import { Component, ChangeDetectionStrategy, Input, OnInit, inject } from '@angular/core';
import { environment } from '@src/environments/environment';
import { PagesService } from '@src/app/modules/pages';
import { SessionService } from '@src/app/modules/auth';

import { DESKTOP_NAVIGATION } from '../constants';

@Component({
  selector: 'app-navigation-desktop',
  templateUrl: './navigation-desktop.component.html',
  styleUrls: ['./navigation-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationDesktopComponent implements OnInit {
  private readonly pagesService = inject(PagesService);
  private readonly session = inject(SessionService);

  @Input() isOpen?: boolean;

  readonly navTree = DESKTOP_NAVIGATION;

  readonly pagesNavItems$ = this.pagesService.pagesForNavigation$;

  readonly appVersion = environment.appVersion;

  get associationMenuVisible() {
    return !!this.session.appConfig?.showAssociationSwitchControl;
  }

  ngOnInit(): void {
    this.pagesService.getPagesForNavigation();
  }
}
